import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/contexts/auth.context";
import { LogOut } from "lucide-react";

/**
 * This is the logout button component.
 * It is used to logout the user.
 * It is a button that when clicked, will logout the user.
 *
 *
 * @returns The logout button component
 */
export const LogoutButton = () => {
	const { logout } = useAuth();
	return (
		<Button variant="ghost" onClick={logout}>
			<LogOut />
			Logout
		</Button>
	);
};
